export default [
    {
        path: '/chat_list/chat',
        name: 'chat',
        component: () => import(/* webpackChunkName: "chat" */ '../views/chat_list/chat/main')
    },
    {
        path: '/chat_list/history',
        name: 'chat_history',
        component: () => import(/* webpackChunkName: "chat" */ '../views/chat_list/history/main')
    },
    {
        path: '/chat_list/history_detail',
        name: 'chat_history_detail',
        component: () => import(/* webpackChunkName: "chat" */ '../views/chat_list/history_detail/main')
    },
    {
        path: '/pages/packageA/frequent_expressions/main',
        name: 'frequent_expressions',
        component: () => import(/* webpackChunkName: "chat" */ '../views/packageA/frequent_expressions/main')
    },
]